import * as d3 from "d3";

export const TIMELINE_MARGINS = { top: 0, right: 15, bottom: 0, left: 80 };

export const computePlotTicks = ({
    startDate,
    endDate,
    plotWidth,
}: {
    startDate: Date;
    endDate: Date;
    plotWidth?: number;
}) => {
    const timeSpan = endDate.getTime() - startDate.getTime();

    // Determine format based on time span
    let tickFormat: (date: Date) => string;
    let numTicks: number;
    if (timeSpan < 7 * 24 * 60 * 60 * 1000) {
        // Less than a week: show date and time
        tickFormat = d3.utcFormat("%b %d, %I:%M %p");
        numTicks = 8;
    } else {
        // A week or more: show full date with year
        tickFormat = d3.utcFormat("%b %d, %Y");
        numTicks = 10;
    }

    if (plotWidth && plotWidth < 800) {
        numTicks = numTicks / 2;
    }

    // Generate ticks
    const tickEach = timeSpan / numTicks;
    const tickValues: Date[] = [];
    for (let i = 0; i <= numTicks; i++) {
        tickValues.push(new Date(startDate.getTime() + i * tickEach));
    }

    return {
        tickFormat,
        tickValues: tickValues,
    };
};
